import { trackGeneralEvent } from '@scentregroup/shared/helpers/analytics-utils/track-event'
import {
  INationalStoreDirectoryItem,
  isINationalStoreDirectoryStoreItem,
} from './types'

export function trackClickNationalStoreDirectoryItem(
  item: INationalStoreDirectoryItem
): React.MouseEventHandler<HTMLLinkElement> {
  if (isINationalStoreDirectoryStoreItem(item)) {
    return e => {
      const target = e.currentTarget
      trackGeneralEvent('Store Selected', undefined, undefined, undefined, {
        properties: {
          ['content_id']: item.id,
          ['content_source']: `contentful_${item.spaceId}`,
          ['content_type']: 'Store',
          ['content_title']: item.title,
          ['store_slug']: item.slug,
          ['centre_slug']: item.centreSlug,
          ...(target.innerText ? { ['link_text']: target.innerText } : null),
          ['link_url']: target.href,
          ['context']: 'National Store Directory',
        },
      })
    }
  } else {
    return e => {
      const target = e.currentTarget
      trackGeneralEvent('Retailer Selected', undefined, undefined, undefined, {
        properties: {
          ['content_id']: item.id,
          ['content_source']: `contentful_${item.spaceId}`,
          ['content_type']: 'Retailer',
          ['content_title']: item.title,
          ['retailer_slug']: item.slug,
          ...(target.innerText ? { ['link_text']: target.innerText } : null),
          ['link_url']: target.href,
          ['context']: 'National Store Directory',
        },
      })
    }
  }
}
